import http from './http';
import AppConfig from '../AppConfig';
import { UserProfileResponse } from '../types/UserProfile';

/**
 * Fetches user profile data from the Compliance Education API
 * Note: Authentication is handled automatically by the http utility (Authorization header with ID token)
 */
export async function fetchUserProfile(): Promise<UserProfileResponse> {
  const url = `${AppConfig.complianceEducationApiUrl}/user/profile`;
  
  const response = await http.get(url);
  
  if (!response.ok) {
    let errorText: string;
    try {
      // Try to get error text from response
      errorText = await response.text();
    } catch (e) {
      // If response.text() fails, fall back to status text or generic message
      errorText = response.statusText || `HTTP ${response.status}`;
    }
    throw new Error(`Failed to fetch user profile: ${response.status} ${errorText}`);
  }
  
  return await response.json();
}

